<template>
  <div class="neon-staff-dashboard">
    <!-- Background Elements -->
    <div class="page-grid"></div>
    <div class="page-orb orb-1"></div>
    <div class="page-orb orb-2"></div>
    <div class="page-orb orb-3"></div>

    <!-- Top Navigation -->
    <div class="top-nav">
      <div class="nav-container">
        <div class="nav-brand">
          <img src="@/assets/CODE FORGE.png" alt="logo" class="nav-logo" />
          <span>CODE FORGE</span>
          <span class="nav-badge">STAFF</span>
        </div>

        <div class="nav-actions">
          <div class="nav-user" @click="showUserMenu = !showUserMenu">
            <img src="https://avatars.githubusercontent.com/u/9919?s=64&v=4" alt="avatar" class="user-avatar" />
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div v-if="showUserMenu" class="user-dropdown" @click.stop>
              <button @click="goToSettings">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M14.625 9.75C14.5125 10.125 14.4375 10.5375 14.4375 10.9875C14.4375 11.4375 14.5125 11.85 14.625 12.225L13.3125 13.35C13.2 13.4625 13.1625 13.6125 13.2375 13.7625L14.5125 15.9375C14.5875 16.0875 14.7375 16.125 14.8875 16.0875L16.4625 15.4875C16.9125 15.825 17.4375 16.0875 17.9625 16.2375L18.225 17.925C18.225 18.075 18.3375 18.1875 18.4875 18.1875H21.0375C21.1875 18.1875 21.3 18.075 21.3 17.925L21.5625 16.2375C22.0875 16.0875 22.6125 15.825 23.0625 15.4875L24.6375 16.0875C24.7875 16.125 24.9375 16.0875 25.0125 15.9375L26.2875 13.7625C26.3625 13.6125 26.325 13.4625 26.2125 13.35L24.9 12.225C25.05 11.85 25.125 11.4375 25.125 10.9875C25.125 10.5375 25.05 10.125 24.9 9.75L26.2125 8.625C26.325 8.5125 26.3625 8.3625 26.2875 8.2125L25.0125 6.0375C24.9375 5.8875 24.7875 5.85 24.6375 5.8875L23.0625 6.4875C22.6125 6.15 22.0875 5.8875 21.5625 5.7375L21.3 4.05C21.3 3.9 21.1875 3.7875 21.0375 3.7875H18.4875C18.3375 3.7875 18.225 3.9 18.225 4.05L17.9625 5.7375C17.4375 5.8875 16.9125 6.15 16.4625 6.4875L14.8875 5.8875C14.7375 5.85 14.5875 5.8875 14.5125 6.0375L13.2375 8.2125C13.1625 8.3625 13.2 8.5125 13.3125 8.625L14.625 9.75Z" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <span>Profile</span>
              </button>
              <div class="dropdown-divider"></div>
              <button @click="logout">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-content">
          <div class="hero-text">
            <h1 class="hero-title">
              Welcome back, <span class="hero-name">{{ displayName }}</span>
            </h1>
            <p class="hero-subtitle">
              Close deals faster with a focused, gamified workflow.
            </p>
          </div>

          <div class="hero-actions">
            <button class="action-btn btn-primary" @click="goToOnboarding">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 5V15M5 10H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span>Onboard Customer</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToLeads">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 12C6.68629 12 4 14.6863 4 18H16C16 14.6863 13.3137 12 10 12Z" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>View Leads</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToTemplates">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 4H16M4 8H16M4 12H16M4 16H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>Templates</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToProducts">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3 3H17V17H3V3Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M3 8H17M8 3V17" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>Products</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToPayment">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>Payments</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Dashboard Content -->
    <div class="dashboard-container">
      <!-- KPI Row -->
      <div class="kpi-row">
        <div class="kpi-card card-cyan">
          <div class="kpi-content">
            <div class="kpi-text">
              <div class="kpi-label">Active Customers</div>
              <div class="kpi-value">{{ activeCustomers }}</div>
              <div class="kpi-meta">Live from Firestore</div>
            </div>
            <div class="kpi-icon icon-cyan">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="kpi-card card-purple">
          <div class="kpi-content">
            <div class="kpi-text">
              <div class="kpi-label">Open Leads</div>
              <div class="kpi-value">{{ openLeads }}</div>
              <div class="kpi-meta">Live from Firestore</div>
            </div>
            <div class="kpi-icon icon-purple">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M16 21V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V21M4 7H20M6 21H18C19.1046 21 20 20.1046 20 19V9C20 7.89543 19.1046 7 18 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="pipeline-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Pipeline Health (7 days)</span>
            </div>
            <div class="card-meta">new → contacted → qualified</div>
          </div>
          <div class="pipeline-charts">
            <div class="chart-section">
              <div class="chart-label">Inbound</div>
              <div class="chart-placeholder chart-cyan">
                <div v-for="(val, i) in sparkInbound" :key="`inbound-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkInbound.reduce((a, b) => a + b, 0) }} total</div>
            </div>
            <div class="chart-section">
              <div class="chart-label">Progressing</div>
              <div class="chart-placeholder chart-purple">
                <div v-for="(val, i) in sparkProgress" :key="`progress-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkProgress.reduce((a, b) => a + b, 0) }} total</div>
            </div>
            <div class="chart-section">
              <div class="chart-label">Demos/Proposals</div>
              <div class="chart-placeholder chart-pink">
                <div v-for="(val, i) in sparkProposals" :key="`proposals-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkProposals.reduce((a, b) => a + b, 0) }} total</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Second Row -->
      <div class="cards-row">
        <!-- Today's Focus -->
        <div class="focus-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Today's Focus</span>
            </div>
            <div class="focus-progress">
              <svg class="progress-ring" width="40" height="40">
                <circle class="ring-bg" cx="20" cy="20" r="16" />
                <circle 
                  class="ring-fill" 
                  cx="20" 
                  cy="20" 
                  r="16"
                  :style="{ strokeDashoffset: progressOffset }"
                />
              </svg>
              <span class="progress-text">{{ Math.round(focusPercent) }}%</span>
            </div>
          </div>

          <div class="focus-list">
            <div 
              v-for="item in focusList" 
              :key="item.id" 
              class="focus-item"
              @click="toggleFocus(item)"
            >
              <label class="focus-checkbox">
                <input type="checkbox" v-model="item.done" @click.stop />
                <span class="checkbox-mark"></span>
              </label>
              <div class="focus-content">
                <div class="focus-title" :class="{ done: item.done }">
                  {{ item.title }}
                </div>
                <div class="focus-subtitle">{{ item.sub }}</div>
              </div>
              <span v-if="item.badge" class="focus-badge">{{ item.badge }}</span>
            </div>
          </div>

          <div class="card-footer">
            <button class="footer-btn btn-gradient" @click="goToLeads">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.33334 5.33334L8.00001 8.00001L12.6667 5.33334M3.33334 10.6667L8.00001 13.3333L12.6667 10.6667M8.00001 2.66667L3.33334 5.33334L8.00001 8.00001L12.6667 5.33334L8.00001 2.66667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Jump to Leads</span>
            </button>
            <button class="footer-btn btn-text" @click="resetFocus">Reset</button>
          </div>
        </div>

        <!-- Team Leaderboard -->
        <div class="leaderboard-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 9H4.5C3.67157 9 3 9.67157 3 10.5V19.5C3 20.3284 3.67157 21 4.5 21H6M6 9V21M6 9H10M6 21H10M18 9H19.5C20.3284 9 21 9.67157 21 10.5V19.5C21 20.3284 20.3284 21 19.5 21H18M18 9V21M18 9H14M18 21H14M10 3H14V21H10V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Team Leaderboard</span>
            </div>
            <div class="card-meta">motivates healthy competition</div>
          </div>

          <div v-if="!leaderboardLoading" class="leaderboard-list">
            <div 
              v-for="(m, i) in leaderboard" 
              :key="m.id"
              class="leaderboard-item"
            >
              <div class="leader-avatar" :class="getRankClass(i)">
                <span>{{ m.initials }}</span>
              </div>
              <div class="leader-info">
                <div class="leader-name">{{ m.name }}</div>
                <div class="leader-stats">{{ m.deals }} deals • {{ m.points }} pts</div>
              </div>
              <div class="leader-rank" :class="getRankClass(i)">
                #{{ i + 1 }}
              </div>
            </div>
          </div>

          <div v-else class="loading-skeleton">
            <div v-for="i in 3" :key="i" class="skeleton-item"></div>
          </div>

          <div class="card-footer">
            <button class="footer-btn btn-text" @click="goToLeads">
              View pipeline →
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer-section">
      <div class="footer-content">
        © {{ new Date().getFullYear() }} Code Forge Development — All rights reserved.
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { auth, db } from '../firebase'
import router from '../router'
import {
  collection, onSnapshot, query, where, orderBy, limit, doc, getDoc,
  getCountFromServer, collectionGroup
} from 'firebase/firestore'

const displayName = ref('Staff Member')
const showUserMenu = ref(false)

/* ----- Header KPIs ----- */
const activeCustomers = ref(7)
const openLeads = ref(319)
let unsubCustomers, unsubLeads, unsubLeaderboard, unsubInbound, unsubInteractions, unsubNextActions

/* ===== Pipeline Health (dynamic) ===== */
const sparkInbound = ref([2, 5, 8, 4, 7, 9, 6])
const sparkProgress = ref([1, 3, 5, 7, 4, 6, 8])
const sparkProposals = ref([0, 2, 1, 4, 3, 5, 4])

function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x }
function windowStart() { const t = new Date(); t.setDate(t.getDate() - 6); return startOfDay(t) }
function dayIdx(ts) {
  const start = windowStart().getTime()
  const date = ts?.seconds ? new Date(ts.seconds * 1000) : new Date(ts)
  const day = startOfDay(date).getTime()
  const i = Math.floor((day - start) / 86400000)
  return (i >= 0 && i < 7) ? i : -1
}
function empty7() { return [0, 0, 0, 0, 0, 0, 0] }

function subInbound() {
  const qRef = query(collection(db, 'leads'), where('createdAt', '>=', windowStart()))
  unsubInbound = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => { const i = dayIdx(docu.data().createdAt); if (i >= 0) buckets[i]++ })
    sparkInbound.value = buckets
  })
}

function subInteractions() {
  const qRef = query(collectionGroup(db, 'interactions'), where('at', '>=', windowStart()))
  unsubInteractions = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => { const i = dayIdx(docu.data().at); if (i >= 0) buckets[i]++ })
    sparkProgress.value = buckets
  })
}

function subNextActions() {
  const qRef = query(collection(db, 'leads'), where('nextAction.dueAt', '>=', windowStart()))
  unsubNextActions = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => {
      const d = docu.data()?.nextAction
      if (!d || !d.dueAt) return
      if (!['demo', 'proposal'].includes((d.type || '').toLowerCase())) return
      const i = dayIdx(d.dueAt); if (i >= 0) buckets[i]++
    })
    sparkProposals.value = buckets
  })
}

/* ===== Today's Focus ===== */
const focusList = ref([
  { id: 1, title: 'Call 3 new leads', sub: 'Keep the pipeline warm', done: false, badge: 'Outbound' },
  { id: 2, title: 'Send 2 follow-up emails', sub: 'Move deals to qualified', done: false, badge: 'Follow-up' },
  { id: 3, title: 'Schedule 1 demo', sub: 'Target high-intent prospects', done: false, badge: 'Demo' }
])
const focusPercent = ref(0)

const progressOffset = computed(() => {
  const circumference = 2 * Math.PI * 16
  return circumference - (focusPercent.value / 100) * circumference
})

const recalcFocus = () => {
  const total = focusList.value.length || 1
  const done = focusList.value.filter(x => x.done).length
  focusPercent.value = (done / total) * 100
}
const toggleFocus = (item) => { item.done = !item.done; recalcFocus() }
const resetFocus = () => { focusList.value.forEach(i => { i.done = false }); recalcFocus() }
recalcFocus()

/* ===== Team Leaderboard ===== */
const leaderboard = ref([
  { id: '1', name: 'Sarah Johnson', initials: 'SJ', points: 1368, deals: 8 },
  { id: '2', name: 'Christian Vernet', initials: 'CV', points: 1170, deals: 6 },
  { id: '3', name: 'Henriella Severe', initials: 'HS', points: 560, deals: 3 },
  { id: '4', name: 'Riona Severe', initials: 'RS', points: 240, deals: 1 },
  { id: '5', name: 'Enrica Severe', initials: 'ES', points: 140, deals: 1 }
])
const leaderboardLoading = ref(false)

const getRankClass = (index) => {
  if (index === 0) return 'rank-1'
  if (index === 1) return 'rank-2'
  if (index === 2) return 'rank-3'
  return 'rank-other'
}

const initialsFrom = (first, last, email) => {
  const n = `${first || ''} ${last || ''}`.trim()
  if (n) return n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase()
  if (email) return email.replace(/@.*/, '').slice(0, 2).toUpperCase()
  return '??'
}

async function hydrateUserRow(uid, points) {
  const userSnap = await getDoc(doc(db, 'users', uid))
  const u = userSnap.exists() ? userSnap.data() : {}
  const name = (u.firstName || u.fullName || '').trim()
    ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.fullName
    : (u.email || 'Unknown User')

  let deals = 0
  try {
    const wonQ = query(collection(db, 'leads'), where('ownerUid', '==', uid), where('status', '==', 'won'))
    const wonCount = await getCountFromServer(wonQ)
    deals = wonCount.data().count || 0
  } catch (_) { deals = 0 }

  return {
    id: uid,
    name,
    initials: initialsFrom(u.firstName, u.lastName, u.email),
    points: typeof points === 'number' ? points : (points?.toNumber?.() ?? 0),
    deals
  }
}

function subscribeLeaderboard() {
  const statsQ = query(collection(db, 'user_stats'), orderBy('points', 'desc'), limit(10))
  unsubLeaderboard = onSnapshot(statsQ, async (snap) => {
    leaderboardLoading.value = true
    const rows = await Promise.all(snap.docs.map(async d => {
      const data = d.data() || {}
      return hydrateUserRow(d.id, data.points ?? 0)
    }))
    leaderboard.value = rows
    leaderboardLoading.value = false
  }, () => { leaderboardLoading.value = false })
}

/* ===== Mount / Unmount ===== */
onMounted(() => {
  try {
    unsubCustomers = onSnapshot(collection(db, 'customers'), snap => { activeCustomers.value = snap.size })
    const openStatuses = ['new', 'contacted', 'qualified', 'proposal']
    unsubLeads = onSnapshot(query(collection(db, 'leads'), where('status', 'in', openStatuses)), snap => { openLeads.value = snap.size })
    
    subscribeLeaderboard()
    subInbound()
    subInteractions()
    subNextActions()
  } catch (e) {
    console.error('Firebase subscription error:', e)
  }
})

onBeforeUnmount(() => {
  unsubCustomers?.(); unsubLeads?.(); unsubLeaderboard?.()
  unsubInbound?.(); unsubInteractions?.(); unsubNextActions?.()
})

/* ----- Nav/Auth ----- */
const logout = async () => { 
  showUserMenu.value = false
  await auth.signOut()
  router.push('/') 
}
const goToSettings = () => {
  showUserMenu.value = false
  router.push('/staff-manage-settings')
}
const goToOnboarding = () => router.push('/staff-onboard-customer')
const goToPayment = () => router.push('/staff-payments')
const goToLeads = () => router.push('/staff-leads')
const goToTemplates = () => router.push('/staff/templates')
const goToProducts = () => router.push('/staff/products')
</script>

<style scoped>
  
  .neon-staff-dashboard {
    min-height: 100vh;
    background: #0a0118;
    font-family: 'Sora', sans-serif;
    color: #ffffff;
    overflow-x: hidden;
  }
  
  /* Background Elements */
  .page-grid {
    position: fixed;
    inset: 0;
    background-image:
      linear-gradient(to right, rgba(0, 255, 245, 0.15) 2px, transparent 2px),
      linear-gradient(to bottom, rgba(123, 47, 247, 0.15) 2px, transparent 2px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, black 20%, transparent 70%);
    animation: grid-flow 30s linear infinite;
    pointer-events: none;
    z-index: 0;
  }
  
  @keyframes grid-flow {
    0% { transform: translate(0, 0); }
    100% { transform: translate(60px, 60px); }
  }
  
  .page-orb {
    position: fixed;
    border-radius: 50%;
    filter: blur(180px);
    opacity: 0.7;
    animation: orb-float 20s ease-in-out infinite;
    mix-blend-mode: screen;
    pointer-events: none;
    z-index: 0;
  }
  
  .orb-1 {
    width: 800px;
    height: 800px;
    background: radial-gradient(circle, #00fff5, #7b2ff7);
    top: -300px;
    right: -300px;
  }
  
  .orb-2 {
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, #ff006e, #ffbe0b);
    bottom: -250px;
    left: -250px;
    animation-delay: 7s;
  }
  
  .orb-3 {
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, #7b2ff7, #ff006e);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: 14s;
  }
  
  @keyframes orb-float {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(100px, -100px) scale(1.2); }
    66% { transform: translate(-80px, 80px) scale(0.9); }
  }
  
  /* Top Navigation */
  .top-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background: linear-gradient(90deg, rgba(123, 47, 247, 0.95), rgba(255, 0, 110, 0.95));
    border-bottom: 3px solid;
    border-image: linear-gradient(90deg, #00fff5, #7b2ff7, #ff006e) 1;
    backdrop-filter: blur(20px);
    box-shadow: 
      0 0 60px rgba(0, 255, 245, 0.5),
      0 4px 30px rgba(0, 0, 0, 0.5);
  }
  
  .nav-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }
  
  .nav-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 16px;
    font-weight: 900;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    letter-spacing: 0.1em;
    text-shadow: 0 0 20px rgba(0, 255, 245, 0.8);
  }
  
  .nav-logo {
    width: 36px;
    height: 36px;
    filter: drop-shadow(0 0 15px #00fff5);
    transition: transform 0.3s ease;
  }
  
  .nav-logo:hover {
    transform: rotate(180deg) scale(1.1);
  }
  
  .nav-badge {
    padding: 6px 16px;
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.1em;
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
  }
  
  .nav-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .nav-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
  }
  
  .nav-user:hover {
    background: rgba(0, 255, 245, 0.15);
    border-color: #00fff5;
    box-shadow: 0 0 20px rgba(0, 255, 245, 0.4);
  }
  
  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #00fff5;
    box-shadow: 0 0 20px rgba(0, 255, 245, 0.6);
  }
  
  .user-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: linear-gradient(135deg, rgba(26, 11, 46, 0.98), rgba(10, 1, 24, 0.98));
    border: 2px solid #00fff5;
    border-radius: 10px;
    padding: 8px;
    min-width: 180px;
    box-shadow: 0 0 40px rgba(0, 255, 245, 0.5);
    z-index: 1000;
  }
  
  .user-dropdown button {
    width: 100%;
    padding: 12px 16px;
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
    font-family: 'Sora', sans-serif;
    display: flex;
    align-items: center;
    gap: 10px;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  }
  
  .user-dropdown button:hover {
    background: rgba(0, 255, 245, 0.2);
    color: #00fff5;
    text-shadow: 0 0 20px rgba(0, 255, 245, 1);
  }
  
  .dropdown-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0, 255, 245, 0.5), transparent);
    margin: 8px 0;
  }
  
  /* Hero Section */
  .hero-section {
    position: relative;
    padding: 100px 0 80px;
    background:
      radial-gradient(circle at 20% 30%, rgba(0, 255, 245, 0.4), transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(255, 0, 110, 0.4), transparent 50%),
      radial-gradient(circle at 50% 50%, rgba(123, 47, 247, 0.3), transparent 60%),
      linear-gradient(135deg, #1a0b2e 0%, #0a0118 50%, #1a0b2e 100%);
    background-size: 200% 200%;
    animation: hero-breathe 25s ease-in-out infinite;
    overflow: hidden;
  }
  
  @keyframes hero-breathe {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  .hero-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    position: relative;
    z-index: 2;
  }
  
  .hero-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 32px;
  }
  
  .hero-text {
    flex: 1;
    min-width: 300px;
  }
  
  .hero-title {
    font-size: clamp(36px, 5vw, 56px);
    font-weight: 900;
    color: #ffffff;
    margin-bottom: 20px;
    line-height: 1.2;
    letter-spacing: -0.02em;
    text-shadow: 
      0 0 30px rgba(255, 255, 255, 0.8),
      0 0 60px rgba(0, 255, 245, 0.5);
  }
  
  .hero-name {
    display: inline-block;
    background: linear-gradient(135deg, #00fff5, #7b2ff7, #ff006e, #ffbe0b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    background-size: 300% 300%;
    animation: gradient-shift 4s ease infinite;
    filter: drop-shadow(0 0 40px rgba(0, 255, 245, 0.8));
    text-shadow: none;
  }
  
  @keyframes gradient-shift {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  .hero-subtitle {
    font-size: 20px;
    line-height: 1.7;
    color: #ffffff;
    opacity: 0.95;
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  }
  
  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }
  
  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 14px 24px;
    border: none;
    border-radius: 12px;
    font-family: 'Sora', sans-serif;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .btn-primary {
    background: linear-gradient(135deg, #ff006e, #fb5607, #ffbe0b);
    background-size: 200% 200%;
    color: #ffffff;
    box-shadow: 
      0 0 50px rgba(255, 0, 110, 0.8),
      0 4px 30px rgba(251, 86, 7, 0.5);
    animation: button-gradient 3s ease infinite;
  }
  
  @keyframes button-gradient {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  .btn-primary:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 0 80px rgba(255, 0, 110, 1),
      0 8px 40px rgba(251, 86, 7, 0.7);
  }
  
  .btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border: 3px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);
  }
  
  .btn-secondary:hover {
    background: rgba(0, 255, 245, 0.15);
    border-color: #00fff5;
    box-shadow: 
      0 0 50px rgba(0, 255, 245, 0.6),
      0 4px 20px rgba(0, 255, 245, 0.3);
  }
  
  /* Dashboard Container */
  .dashboard-container {
    max-width: 1400px;
    margin: -60px auto 0;
    padding: 0 24px 80px;
    position: relative;
    z-index: 3;
  }
  
  /* KPI Row */
  .kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 28px;
    margin-bottom: 36px;
  }
  
  .kpi-card {
    background: rgba(255, 255, 255, 0.05);
    border: 3px solid;
    border-radius: 20px;
    padding: 28px;
    backdrop-filter: blur(20px);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .kpi-card::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .kpi-card:hover {
    transform: translateY(-6px);
  }
  
  .card-cyan {
    border-color: #00fff5;
    box-shadow: 0 0 40px rgba(0, 255, 245, 0.6);
  }
  
  .card-cyan::before {
    background: radial-gradient(circle at top right, rgba(0, 255, 245, 0.2), transparent 60%);
  }
  
  .card-cyan:hover {
    box-shadow: 0 0 80px rgba(0, 255, 245, 1);
  }
  
  .card-cyan:hover::before {
    opacity: 1;
  }
  
  .card-purple {
    border-color: #7b2ff7;
    box-shadow: 0 0 40px rgba(123, 47, 247, 0.6);
  }
  
  .card-purple::before {
    background: radial-gradient(circle at top right, rgba(123, 47, 247, 0.2), transparent 60%);
  }
  
  .card-purple:hover {
    box-shadow: 0 0 80px rgba(123, 47, 247, 1);
  }
  
  .card-purple:hover::before {
    opacity: 1;
  }
  
  .kpi-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  
  .kpi-text {
    flex: 1;
  }
  
  .kpi-label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #ffffff;
    margin-bottom: 10px;
    font-family: 'Space Mono', monospace;
    opacity: 0.9;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .kpi-value {
    font-size: 48px;
    font-weight: 900;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    line-height: 1;
    margin-bottom: 10px;
    text-shadow: 
      0 0 30px rgba(255, 255, 255, 0.8),
      0 0 60px rgba(0, 255, 245, 0.6);
  }
  
  .kpi-meta {
    font-size: 13px;
    color: #ffffff;
    opacity: 0.8;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  }
  
  .kpi-icon {
    width: 72px;
    height: 72px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid;
    transition: all 0.3s ease;
  }
  
  .icon-cyan {
    border-color: #00fff5;
    background: linear-gradient(135deg, rgba(0, 255, 245, 0.3), rgba(123, 47, 247, 0.3));
    color: #00fff5;
    box-shadow: 0 0 30px rgba(0, 255, 245, 0.6);
  }
  
  .icon-cyan svg {
    filter: drop-shadow(0 0 15px #00fff5);
  }
  
  .kpi-card:hover .icon-cyan {
    transform: rotate(8deg) scale(1.15);
    box-shadow: 0 0 50px rgba(0, 255, 245, 1);
  }
  
  .icon-purple {
    border-color: #7b2ff7;
    background: linear-gradient(135deg, rgba(123, 47, 247, 0.3), rgba(255, 0, 110, 0.3));
    color: #7b2ff7;
    box-shadow: 0 0 30px rgba(123, 47, 247, 0.6);
  }
  
  .icon-purple svg {
    filter: drop-shadow(0 0 15px #7b2ff7);
  }
  
  .kpi-card:hover .icon-purple {
    transform: rotate(8deg) scale(1.15);
    box-shadow: 0 0 50px rgba(123, 47, 247, 1);
  }
  
  /* Pipeline Card */
  .pipeline-card {
    background: rgba(255, 255, 255, 0.05);
    border: 3px solid #ff006e;
    border-radius: 20px;
    padding: 28px;
    backdrop-filter: blur(20px);
    box-shadow: 0 0 40px rgba(255, 0, 110, 0.6);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .pipeline-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at top, rgba(255, 0, 110, 0.2), transparent 60%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .pipeline-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 0 80px rgba(255, 0, 110, 1);
  }
  
  .pipeline-card:hover::before {
    opacity: 1;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    flex-wrap: wrap;
    gap: 12px;
    position: relative;
    z-index: 1;
  }
  
  .card-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
  }
  
  .card-title svg {
    color: #ff006e;
    filter: drop-shadow(0 0 10px #ff006e);
  }
  
  .card-meta {
    font-size: 12px;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    opacity: 0.9;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  }
  
  .pipeline-charts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 24px;
    position: relative;
    z-index: 1;
  }
  
  .chart-section {
    text-align: center;
  }
  
  .chart-label {
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 14px;
    font-family: 'Space Mono', monospace;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .chart-placeholder {
    height: 100px;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    gap: 6px;
    border-radius: 8px;
    padding: 12px 8px;
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid rgba(255, 255, 255, 0.1);
  }
  
  .chart-bar {
    flex: 1;
    border-radius: 4px 4px 0 0;
    transition: all 0.3s ease;
    min-height: 5%;
    max-width: 20px;
  }
  
  .chart-placeholder:hover .chart-bar {
    filter: brightness(1.3);
  }
  
  .chart-cyan {
    background: rgba(0, 255, 245, 0.05);
    border-color: rgba(0, 255, 245, 0.2);
  }
  
  .chart-cyan .chart-bar {
    background: linear-gradient(to top, #00fff5, #7b2ff7);
    box-shadow: 0 0 15px rgba(0, 255, 245, 0.6);
  }
  
  .chart-purple {
    background: rgba(123, 47, 247, 0.05);
    border-color: rgba(123, 47, 247, 0.2);
  }
  
  .chart-purple .chart-bar {
    background: linear-gradient(to top, #7b2ff7, #ff006e);
    box-shadow: 0 0 15px rgba(123, 47, 247, 0.6);
  }
  
  .chart-pink {
    background: rgba(255, 0, 110, 0.05);
    border-color: rgba(255, 0, 110, 0.2);
  }
  
  .chart-pink .chart-bar {
    background: linear-gradient(to top, #ff006e, #ffbe0b);
    box-shadow: 0 0 15px rgba(255, 0, 110, 0.6);
  }
  
  .chart-total {
    margin-top: 10px;
    font-size: 11px;
    font-weight: 700;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    opacity: 0.7;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }
  
  /* Cards Row */
  .cards-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    gap: 28px;
  }
  
  /* Focus Card */
  .focus-card {
    background: rgba(255, 255, 255, 0.05);
    border: 3px solid #00fff5;
    border-radius: 20px;
    padding: 28px;
    backdrop-filter: blur(20px);
    box-shadow: 0 0 40px rgba(0, 255, 245, 0.6);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .focus-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at top, rgba(0, 255, 245, 0.2), transparent 60%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .focus-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 0 80px rgba(0, 255, 245, 1);
  }
  
  .focus-card:hover::before {
    opacity: 1;
  }
  
  .focus-progress {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .progress-ring {
    transform: rotate(-90deg);
  }
  
  .ring-bg {
    fill: none;
    stroke: rgba(255, 255, 255, 0.1);
    stroke-width: 4;
  }
  
  .ring-fill {
    fill: none;
    stroke: #00fff5;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 100.53;
    transition: stroke-dashoffset 0.5s ease;
    filter: drop-shadow(0 0 10px #00fff5);
  }
  
  .progress-text {
    position: absolute;
    font-size: 13px;
    font-weight: 900;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .focus-list {
    margin: 28px 0;
    position: relative;
    z-index: 1;
  }
  
  .focus-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    margin-bottom: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid rgba(255, 255, 255, 0.1);
  }
  
  .focus-item:hover {
    background: rgba(0, 255, 245, 0.1);
    border-color: rgba(0, 255, 245, 0.3);
    transform: translateX(6px);
    box-shadow: 0 0 20px rgba(0, 255, 245, 0.3);
  }
  
  .focus-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .focus-checkbox input[type="checkbox"] {
    display: none;
  }
  
  .checkbox-mark {
    width: 26px;
    height: 26px;
    border: 3px solid #00fff5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 0 20px rgba(0, 255, 245, 0.4);
  }
  
  .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark {
    background: #00fff5;
    box-shadow: 0 0 30px rgba(0, 255, 245, 0.8);
  }
  
  .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark::after {
    content: '✓';
    color: #0a0118;
    font-size: 18px;
    font-weight: 900;
  }
  
  .focus-content {
    flex: 1;
  }
  
  .focus-title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 6px;
    transition: all 0.2s ease;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
  }
  
  .focus-title.done {
    text-decoration: line-through;
    opacity: 0.5;
  }
  
  .focus-subtitle {
    font-size: 14px;
    color: #ffffff;
    opacity: 0.8;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.4);
  }
  
  .focus-badge {
    padding: 6px 14px;
    background: linear-gradient(135deg, #00fff5, #7b2ff7);
    border-radius: 20px;
    font-size: 11px;
    font-weight: 800;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 0 20px rgba(0, 255, 245, 0.5);
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
  }
  
  /* Leaderboard Card */
  .leaderboard-card {
    background: rgba(255, 255, 255, 0.05);
    border: 3px solid #7b2ff7;
    border-radius: 20px;
    padding: 28px;
    backdrop-filter: blur(20px);
    box-shadow: 0 0 40px rgba(123, 47, 247, 0.6);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .leaderboard-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at top, rgba(123, 47, 247, 0.2), transparent 60%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .leaderboard-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 0 80px rgba(123, 47, 247, 1);
  }
  
  .leaderboard-card:hover::before {
    opacity: 1;
  }
  
  .leaderboard-list {
    margin: 28px 0;
    position: relative;
    z-index: 1;
  }
  
  .leaderboard-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
    border: 2px solid rgba(255, 255, 255, 0.1);
  }
  
  .leaderboard-item:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateX(6px);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  }
  
  .leader-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 900;
    color: #ffffff;
    border: 3px solid;
    font-family: 'Space Mono', monospace;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
  }
  
  .rank-1 {
    background: linear-gradient(135deg, #ffbe0b, #ff006e);
    border-color: #ffbe0b;
    box-shadow: 0 0 30px rgba(255, 190, 11, 0.8);
  }
  
  .rank-2 {
    background: linear-gradient(135deg, #00fff5, #7b2ff7);
    border-color: #00fff5;
    box-shadow: 0 0 30px rgba(0, 255, 245, 0.8);
  }
  
  .rank-3 {
    background: linear-gradient(135deg, #7b2ff7, #ff006e);
    border-color: #7b2ff7;
    box-shadow: 0 0 30px rgba(123, 47, 247, 0.8);
  }
  
  .rank-other {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  }
  
  .leader-info {
    flex: 1;
  }
  
  .leader-name {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 6px;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
  }
  
  .leader-stats {
    font-size: 13px;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    opacity: 0.8;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.4);
  }
  
  .leader-rank {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 900;
    color: #ffffff;
    font-family: 'Space Mono', monospace;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .loading-skeleton {
    padding: 28px 0;
  }
  
  .skeleton-item {
    height: 70px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 12px;
    margin-bottom: 10px;
  }
  
  @keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  
  /* Card Footer */
  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid rgba(255, 255, 255, 0.1);
    position: relative;
    z-index: 1;
  }
  
  .footer-btn {
    padding: 12px 20px;
    border: none;
    border-radius: 10px;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 10px;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  
  .btn-gradient {
    background: linear-gradient(135deg, #00fff5, #7b2ff7);
    color: #ffffff;
    box-shadow: 0 0 30px rgba(0, 255, 245, 0.6);
  }
  
  .btn-gradient:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 0 50px rgba(0, 255, 245, 0.9),
      0 4px 20px rgba(123, 47, 247, 0.5);
  }
  
  .btn-text {
    background: transparent;
    color: #ffffff;
    opacity: 0.8;
  }
  
  .btn-text:hover {
    color: #00fff5;
    opacity: 1;
    text-shadow: 0 0 20px rgba(0, 255, 245, 1);
  }
  
  /* Footer */
  .footer-section {
    background: linear-gradient(135deg, #1a0b2e, #050011);
    border-top: 3px solid;
    border-image: linear-gradient(90deg, #00fff5, #7b2ff7, #ff006e) 1;
    padding: 24px 0;
    position: relative;
    box-shadow: 0 -20px 80px rgba(0, 255, 245, 0.2) inset;
  }
  
  .footer-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    font-family: 'Space Mono', monospace;
    opacity: 0.9;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  }
  
  /* Responsive */
  @media (max-width: 960px) {
    .hero-content {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .hero-actions {
      width: 100%;
      flex-direction: column;
    }
  
    .action-btn {
      width: 100%;
      justify-content: center;
    }
  
    .kpi-row,
    .cards-row {
      grid-template-columns: 1fr;
    }
  
    .pipeline-charts {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 600px) {
    .dashboard-container {
      margin-top: -40px;
    }
  
    .kpi-card,
    .pipeline-card,
    .focus-card,
    .leaderboard-card {
      padding: 20px;
    }
  
    .hero-title {
      font-size: 32px;
    }
  
    .kpi-value {
      font-size: 36px;
    }
  }
</style>